<template>
    <v-card class="mb-5">
        <v-card-title class="title">{{ name }}</v-card-title>
        <v-divider />
        <v-card-text>
            <v-range-slider
                :value="value || [data.min, data.max]"
                :max="data.max"
                :min="data.min"
                thumb-label="always"
                class="align-center"
                @change="(val) => $emit('change', val)"
            />
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: 'FacetRangeCard',
    props: {
        name: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            default: () => ({ min: 0, max: 0 })
        },
        value: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            max: 0,
            min: 0
        }
    }
}
</script>
